import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';

export const OrderFileUploader = ({ orderId, onUploadComplete }) => {
    const [errorMessage, setErrorMessage] = useState("");

    const onDrop = useCallback(async (acceptedFiles) => {
        const validFiles = acceptedFiles.filter(file => {
            const isValidType = ['application/pdf'].includes(file.type);
            const isValidSize = file.size <= 5 * 1024 * 1024;
            return isValidType && isValidSize;
        });

        if (validFiles.length !== acceptedFiles.length) {
            setErrorMessage("Um ou mais arquivos estão em um formato inválido ou excedem o tamanho de 5MB.");
        } else {
            setErrorMessage("");
        }

        const baseUrl = process.env.REACT_APP_API_URL;
        const accessToken = localStorage.getItem('access_token');

        for (let file of validFiles) {
            const formData = new FormData();
            formData.append('files[]', file);
            console.log(formData);
            try {
                const response = await fetch(`${baseUrl}/orders/${orderId}/files`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: formData
                });

                if (response.ok) {
                    const data = await response.json();
                    onUploadComplete(data.data);
                } else {
                    console.error('Erro ao enviar o arquivo:', response.statusText);
                }
            } catch (error) {
                console.error('Erro ao enviar o arquivo:', error);
            }
        }
    }, [orderId, onUploadComplete]);

    const { getRootProps, getInputProps } = useDropzone({ onDrop, multiple: true });

    return (
        <>
            <div {...getRootProps()} className="p-8 border-dashed border-2 border-gray-400 cursor-pointer text-center mt-4">
                <input {...getInputProps()} />
                <h3 className="text-center text-xl mb-2">Arraste arquivos aqui</h3>
                <p className="text-center text-xs text-slate-400">PDF, DOCX, PNG ou JPG de até 5MB</p>
            </div>
            {errorMessage && (
                <p className="text-red-500 mt-2">{errorMessage}</p>
            )}
        </>
    );
};
